import { useRoute } from 'vue-router'
import { useHead } from '#imports'

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const config = useRuntimeConfig()

  // Function to update OG meta tags
  const updateOgMeta = () => {
    // Use the site URL from the configuration or fallback to a default
    const siteUrl = config.public.siteUrl || 'https://fodboldpakker.dk'
    const isPackageDetail = route.path.startsWith('/packages/') && route.params.slug
    const ogImageUrl = isPackageDetail
      ? `${siteUrl}/api/og/packages/${route.params.slug}.png`
      : `${siteUrl}/api/og/packages.png`

    useHead({
      meta: [
        {
          property: 'og:image',
          content: ogImageUrl,
        },
        {
          name: 'twitter:image',
          content: ogImageUrl,
        },
        {
          property: 'og:image:width',
          content: '1200',
        },
        {
          property: 'og:image:height',
          content: '630',
        },
        {
          property: 'og:type',
          content: 'website',
        },
      ],
    })
  }

  // Update meta tags on initial load
  updateOgMeta()

  // Watch for route changes
  watch(
    () => route.path,
    () => {
      updateOgMeta()
    }
  )
})
